import React from 'react';
import AsyncPage from './async';
import DefaultConsumerLayout from '../../../../components/layout/DefaultConsumerLayout';

export default [
  <DefaultConsumerLayout
    key="/consumer/features/ai-photo-enhancer"
    exact
    path="/consumer/features/ai-photo-enhancer"
    component={AsyncPage}
  />,
];
